import { jsx } from '@amazon/vinyl-tsx'
import { data } from '@amazon/vinyl-observable'
import { ctx } from '@/util/context'
import { fetchRecentlyAddedTracks } from '@/recentlyAdded/recentlyAddedService'
import { LoadingController, LoadingIndicator } from '@/components/LoadingIndicator'
import { VirtualList } from '@/components/VirtualList'
import { TrackRenderer } from '@/track/TrackRenderer'
import type { TrackFields } from '@/track/trackFieldsFrag'
import type { PlayQueueBindingDeps } from '@/playback/playQueueBinding'

const { errorHandler } = ctx('RecentlyAdded')

export type RecentlyAddedDeps = PlayQueueBindingDeps

export interface RecentlyAddedProps {
    readonly deps: RecentlyAddedDeps
}

export function RecentlyAdded(props: RecentlyAddedProps) {
    const loader = new LoadingController()
    const tracks = data<readonly TrackFields[]>([])

    const done = loader.show()
    fetchRecentlyAddedTracks()
        .then((res) => {
            const edges = res.user?.libraryTracks?.edges ?? []
            tracks.value = edges.map((e) => e.node as unknown as TrackFields)
        })
        .catch(errorHandler)
        .finally(done)

    const trackCount = tracks.map((t) => t.length)
    const trackProvider = (index: number): TrackFields | null => tracks.value[index] ?? null

    return (
        <div className="recentlyAddedPage seeAllPage">
            <LoadingIndicator visible={loader.loading} />
            <div className="albumTrackContainer">
                <VirtualList
                    dataProvider={trackProvider}
                    dataProviderThrottle={0}
                    count={trackCount}
                    direction="vertical"
                    variableSizes={false}
                    itemRenderer={(track, index) => (
                        <TrackRenderer track={track} index={index} deps={props.deps} />
                    )}
                    loadingIndicator={<LoadingIndicator />}
                />
            </div>
        </div>
    )
}
